"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const CreateResourcesButton_1 = require("../../../comps/reusables/CreateResourcesButton");
const graphql_1 = require("../../../graphql");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.NewContextButton = () => {
    const { history } = use_react_router_1.default();
    return (react_1.default.createElement(CreateResourcesButton_1.CreateResourcesButton, { label: "New ad context", modalProps: {
            formProps: {
                formikProps: {
                    initialValues: {
                        name: '',
                    },
                },
                mutationProps: {
                    mutation: graphql_1.createContext,
                    onCompleted: data => {
                        if (data && data.createContext) {
                            history.push(`/contexts/${data.createContext.id}`);
                        }
                    },
                },
                valuesToVariables: values => {
                    return {
                        data: {
                            name: values.name,
                        },
                    };
                },
            },
            header: 'New ad context',
        } }));
};
//# sourceMappingURL=NewContextButton.js.map